import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { useGoogleApi } from '@yme/common/hooks';
export const withGoogleApi = (WrappedComponent) => {
    const Enhance = (props) => {
        const { apiKey } = props;
        const { isLoaded } = useGoogleApi(apiKey);
        if (!isLoaded) {
            return null;
        }
        return React.createElement(WrappedComponent, { ...props });
    };
    hoistNonReactStatic(Enhance, WrappedComponent);
    return Enhance;
};
